export default "__VITE_ASSET__Di94p5Ih__"